import AfterFetchComponent from '@/components/base/AfterFetchComponent'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {ManagingCompanies} from "@/models/ManagingCompanies";
import {OprEntityKeys} from "@/models/OprEntityKeys";
import {ExportType} from '@payroll/grid-widget/src/models/ExportType'

import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn'
import {BaseRequest, KeyValuePair} from "@payroll/optimus-common";
import {FieldType, SearchFieldModel} from '@payroll/search-results-widget/src/models/SearchField.model'
import Component from 'vue-class-component'
import {Action, Getter} from 'vuex-class'


@Component({})
export default class ActivityLoansComponent extends AfterFetchComponent {

  @Action('fetchActivityLoans', StoreNamespace.LOANS) fetchActivityLoans: any
  @Action('getSummeryRowForAllActivityLoans', StoreNamespace.LOANS) getSummeryRowForAllActivityLoans: any
  @Getter('mngCompanyName', StoreNamespace.AUTHENTICATION) mngCompanyName!: string;
  @Getter('oprEntityKey', StoreNamespace.AUTHENTICATION) oprEntityKey!: number
  @Action('exportActivityLoans', StoreNamespace.LOANS) exportActivityLoans: any
  @Action('activityLoansSetup', StoreNamespace.LOANS) activityLoansSetup: any

  private searchLoansFields: SearchFieldModel[] = []
  private columns: GridColumn[] = []
  private dataDate: any = "";
  private summary: any = "";
  private ExportType = ExportType
  private baloonType: KeyValuePair[] = [{value: "true", description:"כן"}, {value: "false", description:"לא"}];
  private loanTypes: KeyValuePair[] = [];

  private lastSearchObject = {
    loanDate: null,
    pageNumber: 0,
    pageSize: 10
  };
  private currentPageNumber = 0;
  private toolBarDebtSum: string = ''
  private toolBarFairWorth: string = ''
  private toolBarLoanSum: string = ''


  mounted() {
    this.fetchActivityLoans({requestorCallback: this, requestBody: {pageNumber: 0, pageSize: 10}})
    this.getSummeryRowForAllActivityLoans({
      requestorCallback: this,
    })

    this.activityLoansSetup({
      requestorCallback: this,
    })
    this.initColumns();
  }

  private initSearchFields(): void {
    if (this.loanTypes === null || this.loanTypes.length === 0) {
      return;
    }
    this.searchLoansFields.push({
      label: 'activityLoans.idNumber',
      property: 'clientId',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 16,
      advancedOnly: false,
      bootstrapColumn: 3
    })
    this.searchLoansFields.push({
      label: 'activityLoans.fullName',
      property: 'clientName',
      fieldType: FieldType.TEXT_FIELD,
      advancedOnly: false,
      bootstrapColumn: 3
    })
    this.searchLoansFields.push({
      label: 'activityLoans.loanStartDate',
      property: 'loanDate',
      fieldType: FieldType.DATE_FIELD,
      bootstrapColumn: 3
    })
    this.searchLoansFields.push({
      label: 'activityLoans.loanNumber',
      property: 'loanNumber',
      fieldType: FieldType.NUMBER_FIELD,
      advancedOnly: false,
      bootstrapColumn: 3
    })
    this.searchLoansFields.push({
      label: 'activityLoans.loanEndDateSearchTitle',
      property: 'loanEndDate',
      fieldType: FieldType.DATE_FIELD,
      advancedOnly: true,
      bootstrapColumn: 3
    })
    this.searchLoansFields.push({
      label: 'activityLoans.baloonType',
      property: 'baloon',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.baloonType,
      unSelectFirst: true,
      bootstrapColumn: 3,
      advancedOnly: true,
    })
    this.searchLoansFields.push({
      label: 'activityLoans.loanType',
      property: 'loanType',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.loanTypes,
      unSelectFirst: true,
      bootstrapColumn: 3,
      advancedOnly: true,
    })
  }

  private initColumns(): void {
    this.columns.push({property: 'clientId', header: 'activityLoans.idNumber'} as GridColumn);
    this.columns.push({property: 'clientName', header: 'activityLoans.fullName'} as GridColumn);
    this.columns.push({property: 'loanNum', header: 'activityLoans.loanNumber'} as GridColumn);

    if (!this.isTaasiaAvirit()) {
      this.columns.push({property: 'accountNum', header: 'activityLoans.accountNumber'} as GridColumn);
      this.columns.push({property: 'loanType', header: 'activityLoans.loanType'} as GridColumn);
    }

    this.columns.push({property: 'loanSum', header: 'activityLoans.loanAmount'} as GridColumn);

    if (this.isOprEntityHapoalim()) {
      this.columns.push({property: 'interestAmount', header: 'activityLoans.interestAmount'} as GridColumn);
    }

    if (!this.isCompanyOfLeumi()) {
      this.columns.push({property: 'debtSum', header: 'activityLoans.debtBalance'} as GridColumn);
    }

    this.columns.push({property: 'updatedInterest', header: 'activityLoans.interest'} as GridColumn);
    this.columns.push({property: 'loanStartDate', header: 'activityLoans.loanStartDate'} as GridColumn);
    this.columns.push({property: 'loanpStartDate', header: 'activityLoans.loanpStartDate'} as GridColumn);
    this.columns.push({property: 'loanEndDate', header: 'activityLoans.loanEndDate'} as GridColumn);
    this.columns.push({
      property: 'remainingInterestPayments', header: 'activityLoans.paymentBalance'
    } as GridColumn);

    if (this.isOprEntityHapoalim()) {
      this.columns.push({
        property: 'lastPaymentSum',
        header: 'activityLoans.lastPaymentSum'
      } as GridColumn);
    }

    this.columns.push({property: 'fairWorth', header: 'activityLoans.fairWorth'} as GridColumn);

  }

  private getGridData(searchObject: any): void {

    this.currentPageNumber = searchObject.pageNumber
    this.lastSearchObject = {
      ...searchObject
    }

    if (this.summary) {
      this.summary.fairWorth = this.summary.fairWorth.replace(/[^\d.]/g, '').replace(',', '');
      this.summary.loanSum = this.summary.loanSum.replace(/[^\d.]/g, '').replace(',', '');
      this.summary.debtSum = this.summary.debtSum.replace(/[^\d.]/g, '').replace(',', '');
    }
    if (searchObject.pageNumber === 0) {
      this.summary.fairWorth = 0;
      this.summary.loanSum = 0;
      this.summary.debtSum = 0;
    } else {
      searchObject.pageSize = 10
    }

    searchObject.summary = this.summary;
    this.fetchActivityLoans({
      requestorCallback: this,
      requestBody: searchObject
    })
  }

  onSuccess(data ?: any, requestName ?: string, message ?: string, success ?: boolean): void {
    switch (requestName) {
      case 'fetchActivityLoans':

        this.$emit('successResults', data)
        if (data.results.length > 0) {
          this.dataDate = data.results[0].dataDate;
        }
        this.summary = data.summary

        break;
      case 'activityLoansSummery' :
        this.toolBarDebtSum = data.debtSum
        this.toolBarFairWorth = data.fairWorth
        this.toolBarLoanSum = data.loanSum
        break

      case 'exportActivityLoans' :
        data.fileExtension = 'xlsx'
        this.$emit('successExport', data)
        break

      case 'activityLoansSetup' :
        this.loanTypes = data.loanTypes
        this.initSearchFields()
        break
    }
  }

  private isTaasiaAvirit(): boolean {
    return this.mngCompanyName === ManagingCompanies.TAASIA_AVIRIT.toLowerCase()
  }

  private isCompanyOfLeumi() {
    return this.mngCompanyName === ManagingCompanies.AMI.toLowerCase() ||
      this.mngCompanyName === ManagingCompanies.AMI_OVDEI_MEDINA.toLowerCase() ||
      this.mngCompanyName === ManagingCompanies.HUJI_GEMEL.toLowerCase() ;
  }

  private isOprEntityHapoalim(): boolean {
    return this.oprEntityKey === OprEntityKeys.BANK_HAPOALIM;
  }

  onExportGrid(exportType: ExportType, gridColumns: Array<GridColumn>, searchObject: any): void {
    let exportColumns: GridColumn[] = []
    this.exportActivityLoans({
      requestBody: {
        headerText: this.exportFileName,
        exportType: exportType,
        columnsList: exportColumns,
        searchObject: searchObject
      } as BaseRequest,
      requestorCallback: this
    })
  }

  get exportFileName(): string {
    return '' + this.$t('activityLoans.activityLoansTitle')
  }
}